const rrfConfig = {
    userProfile: 'startuphive_users',
    useFirestoreForProfile: true,
}

export default rrfConfig